
import App from "./App"
import ReactComponent from "./application"
import MainFooter from "./layouts/MainFooter"


ReactComponent.setup({App, MainFooter})
